export enum PageId {
  LANDING = 'landing',
  HOME = 'home',
  REFERENTIAL = 'referential',
  QUIZ = 'quiz',
  QUIZDO = 'quizDo',
  DASHBOARD = 'dashboard',
  COURSE = 'course',
  CONFIGURE = 'configure',
  RESULTS = 'results',
  QUESTION_BOX = 'question-box',
}
